var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPirl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#96b73d",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.594 16.105c.086.258.213.5.377.718l-2.493-2.518a1.399 1.399 0 010-1.97l3.145-3.147c.065-.048.127-.1.187-.154l.091-.08 2.547-2.549a1.376 1.376 0 011.953.003l8.343 8.403a1.408 1.408 0 01-.151 1.801 1.423 1.423 0 01-1.78.195l-7.37-7.44-.008-.01-.024-.026-3.943 3.944-.06.05a.286.286 0 01-.007.008l3.896 3.927a1.399 1.399 0 01-.62 2.332 1.377 1.377 0 01-1.337-.361l-1.996-2.01c-.029-.026-.058-.06-.094-.096l-.092-.092a2.586 2.586 0 01-.187-.237l.045.053-.03-.039a2.531 2.531 0 01-.392-.705zm8.146 2.573l-3.901-3.929a1.399 1.399 0 010-1.97 1.378 1.378 0 011.956.004l1.997 2.01c.028.025.057.06.094.095l.091.092c.052.058.1.12.144.183l.022.027a4.957 4.957 0 00-.086-.119l2.61 2.627a1.4 1.4 0 010 1.972l-3.147 3.148a2.362 2.362 0 00-.19.151l-2.624 2.624a1.376 1.376 0 01-1.954 0l-8.477-8.547a1.408 1.408 0 01.185-1.876 1.383 1.383 0 011.872.01l7.384 7.455.025.03 3.935-3.934.058-.047a.352.352 0 01.006-.006z",
    fill: "#fff",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirl);
export default __webpack_public_path__ + "static/media/pirl.295db2666d24403e6e45c7cb986c795e.svg";
export { ForwardRef as ReactComponent };